import { t } from '@/hooks/web/useI18n';

export default [
  {
    path: '/go-app-org/accountByUnit',
    name: 'accountByUnit',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('帐套管理'),
      remark: t('对平台的帐套信息进行查看、跟踪、维护。'),
    },
    component: () =>
      import(/* webpackChunkName: "org" */ '@/views/go-app-org/accountByUnit/index.vue'),
  },
  {
    path: '/go-app-org/sunAccountMg',
    name: 'sunAccountMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('子账号管理'),
    },
    component: () =>
      import(/* webpackChunkName: "sunAccountMg" */ '@/views/go-app-org/sunAccountMg/index.vue'),
  },
  {
    path: '/go-app-org/orgMg',
    name: 'orgMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('部门管理'),
    },
    component: () => import(/* webpackChunkName: "orgMg" */ '@/views/go-app-org/orgMg/index.vue'),
  },
  {
    path: '/go-app-org/unitRoleMg/unit',
    name: 'unitRoleMgUnit',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('角色管理'),
    },
    component: () => import(/* webpackChunkName: "unitRoleMgUnit" */'@/views/go-app-org/unitRoleMg/index.vue'),
    // component: () =>
    //   import(/* webpackChunkName: "unitRoleMgUnit" */ '@/views/xm-app-org/xmRoleMg'),
  },
  {
    path: '/go-app-org/unitRoleUserMg/unit',
    name: 'unitRoleUserMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('角色人员管理'),
    },
    component: () =>
      import(/* webpackChunkName: "unitRoleMgUnit" */ '@/views/xm-app-org/xmRoleMg'),
  },
  {
    path: '/go-app-org/stationMg',
    name: 'stationMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('岗位管理'),
    },
    component: () =>
      import(/* webpackChunkName: "stationMg" */ '@/views/go-app-org/stationMg/index.vue'),
  },
  {
    path: '/go-app-org/userMg',
    name: 'userMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('人员管理'),
    },
    component: () =>
      import(/* webpackChunkName: "userMg" */ '@/views/go-app-org/userMg/index.vue'),
  },
  {
    path: '/go-app-org/jobLevel',
    name: 'jobLevel',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('职务级别'),
    },
    component: () =>
      import(/* webpackChunkName: "jobLevel" */ '@/views/go-app-org/jobLevel/index.vue'),
  },
  {
    path: '/go-app-org/userSequenceMg',
    name: 'userSequenceMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('人员排序管理'),
    },
    component: () =>
      import(
        /* webpackChunkName: "userSequenceMg" */ '@/views/go-app-org/userSequenceMg/index.vue'
      ),
  },
  {
    path: '/go-app-org/sysResourceMg',
    name: 'sysResourceMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('系统资源管理'),
    },
    component: () =>
      import(/* webpackChunkName: "sysResourceMg" */ '@/views/go-app-org/sysResourceMg/index.vue'),
  },
  {
    path: '/go-app-org/SpecialUserMg',
    name: 'SpecialUserMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('特殊用户管理'),
    },
    component: () =>
      import(/* webpackChunkName: "sysResourceMg" */ '@/views/go-app-org/SpecialUserMg/index.vue'),
  },
  {
    path: '/go-app-org/sysResourceAclMg',
    name: 'sysResourceAclMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('系统资源权限管理'),
    },
    component: () =>
      import(
        /* webpackChunkName: "sysResourceAclMg" */ '@/views/go-app-org/sysResourceAclMg/index.vue'
      ),
  },

  {
    path: '/xm-app-org/notice-mg',
    name: 'noticeMg',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('平台公告'),
    },
    component: () => import(/* webpackChunkName: "noticeMg" */ '@/views/xm-app-org/noticeMg'),
  },

  {
    path: '/xm-app-org/notice-mg/detail',
    name: 'noticeMg-detail',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('平台公告详情'),
    },
    component: () =>
      import(/* webpackChunkName: "noticMg-detail" */ '@/views/xm-app-org/noticeMgDetail'),
  },
];
